module.exports = __webpack_public_path__ + "static/img/1.ba16183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hlw/1.png
// module id = gM1M
// module chunks = 1